'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module3Res3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module3Res3, _Component);

  function Module3Res3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module3Res3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module3Res3.__proto__ || (0, _getPrototypeOf2.default)(Module3Res3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      module: 'Module 3',
      title: 'Preparation Strategies'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module3Res3, [{
    key: 'render',
    value: function render() {
      var styles = require('../Resources.scss');
      var img1 = require('./Assets/img1.jpeg');
      var img2 = require('./Assets/img2.jpg');
      var img3 = require('./Assets/img3.jpeg');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Col,
          { md: 12, sm: 12, xs: 12, lg: 12 },
          _react2.default.createElement(
            'div',
            { className: styles.activityPanel },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              _react2.default.createElement(
                'h3',
                null,
                this.state.module
              ),
              _react2.default.createElement(
                'h2',
                null,
                this.state.title
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Row,
              null,
              _react2.default.createElement(
                ReactBootstrap.Col,
                { md: 12, xs: 12, sm: 12 },
                _react2.default.createElement(
                  'h3',
                  null,
                  'Set a good example and make it fun'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 8, xs: 8, sm: 8 },
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'strong',
                          { className: styles.orangeText },
                          'Lead by example. '
                        ),
                        'If you want your child to eat their fruit and veg, make sure they see you enjoying yours on a regular basis'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Pretend that mashed potato is \'potato glue\' which other vegies love sticking to. Kids can dip spoons of mash into other vegies such as peas, corn and carrot'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Turn a simple pita bread pizza into a fun ',
                        _react2.default.createElement(
                          'strong',
                          { className: styles.orangeText },
                          'Mr Vegie face '
                        ),
                        'by arranging pizza toppings to make eyes, nose, mouth and ears'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 4, xs: 4, sm: 4 },
                  _react2.default.createElement(ReactBootstrap.Image, { src: img1, responsive: true })
                ),
                _react2.default.createElement(
                  'h3',
                  null,
                  'Hide it or disguise it'
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 8, xs: 8, sm: 8 },
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Sneak more goodness in your child\'s diet by ',
                        _react2.default.createElement(
                          'strong',
                          { className: styles.orangeText },
                          'hiding vegies in their favourite food. '
                        ),
                        'For example, add grated carrot and zucchini in bolognaise sauce'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Kids love burgers so \'beef up\' the patty with',
                        _react2.default.createElement(
                          'strong',
                          { className: styles.orangeText },
                          ' extra vegies such as peas, diced celery, grated pumpkin or carrot.'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'Soups such as pumpkin or homemade tomato are popular with kids and full of goodness. Serve in a favourite fun mug with crunchy bread or toast \'soldiers\' for dunking'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 4, xs: 4, sm: 4 },
                  _react2.default.createElement(ReactBootstrap.Image, { src: img2, responsive: true })
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 4, xs: 4, sm: 4 },
                  _react2.default.createElement(ReactBootstrap.Image, { src: img3, responsive: true })
                ),
                _react2.default.createElement(
                  ReactBootstrap.Col,
                  { md: 8, xs: 8, sm: 8 },
                  _react2.default.createElement(
                    'h3',
                    null,
                    'Make it child friendly'
                  ),
                  _react2.default.createElement(
                    'ul',
                    null,
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'strong',
                          { className: styles.orangeText },
                          'Ready-cut pieces of fruit and vegetables '
                        ),
                        'in the lunch box are easy for kids to manage. Check bananas to make sure their tops can be broken and choose mandarins that have loose skin - these are easier to peel'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'strong',
                          { className: styles.orangeText },
                          '\'I can eat a rainbow\''
                        ),
                        ' : for parties, make a fruit rainbow using different coloured fruits. Encourage kids to try each fruit of the rainbow'
                      )
                    ),
                    _react2.default.createElement(
                      'li',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        'On special occasions when lollies are being served, try to combine them with healthier foods. For example, include a marshmallow on a skewer of fruit rather than offering sweets on their own'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: styles.spacer40 })
          )
        )
      );
    }
  }]);
  return Module3Res3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module3Res3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Res3.js
// module id = 1249
// module chunks = 0